import { css } from 'styled-components';
import { fontStyle, themeLight, spacing, borderRadius } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import normalize from './global/normalize';
import typography from './global/typography';
const stylesheet = css(["", " ", " html{overflow-x:hidden;background:", ";color:", ";}main:focus{outline:none;}body{min-height:100%;position:relative;overflow-x:hidden;", ";}a{color:", ";&:visited{color:", ";}&:hover{color:", ";text-decoration:'none';}}h1{margin:", " 0;}h2,h3,h4,h5,h6{margin:", " 0;}a[href]:not([disabled]),button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),iframe,object,[tabindex=\"0\"],[contenteditable]{&:focus,:focus-visible{outline:", ";border-color:", ";border-radius:", ";}}"], normalize, typography, ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, fontStyle.article.articleText, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  theme
}) => theme.typography ? theme.typography.textLink : themeLight.typography.textLink, spacing.space32, spacing.space20, props => props.isMouseClick ? 0 : `2px solid ${nafColor.signature.black}`, nafColor.signature.black, borderRadius.S);
export { normalize, typography };
export default stylesheet;
//# sourceMappingURL=stylesheet.js.map